import React from "react";

/** Form-only skeleton – use inside the form area; header and sidebar stay visible. */
export function CompletionLoader({ show }) {
  if (!show) return null;
  return (
    <div className="completion-form-skeleton" aria-hidden="true">
      <div className="completion-skeleton-step-title skeleton-pulse" />
      <div className="completion-skeleton-content">
        <div className="completion-skeleton-row skeleton-pulse" />
        <div className="completion-skeleton-row skeleton-pulse" />
        <div className="completion-skeleton-row skeleton-pulse" />
        <div className="completion-skeleton-row completion-skeleton-row-short skeleton-pulse" />
      </div>
      <div className="completion-skeleton-actions">
        <div className="completion-skeleton-btn skeleton-pulse" />
        <div className="completion-skeleton-btn skeleton-pulse" />
      </div>
    </div>
  );
}
